<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 sm3 md3>
				<app-profile-menu
					:customer="$page.props.auth.customer.display_name"
					:customer_image="$page.props.auth.customer_image"
				></app-profile-menu>
			</v-flex>
			<v-flex xs12 sm9 md9>
				<app-datatable
					:title="$t('label.my_orders')"
					:endpoint="endpoint"
					:data="items"
					:headers="headers"
				>
					<template v-slot:[`item.subtotal`]="{ item }">
						{{ item.subtotal | currency }}
					</template>
					<template v-slot:[`item.discount`]="{ item }">
						{{ item.discount | currency }}
					</template>
					<template v-slot:[`item.total`]="{ item }">
						{{ item.total | currency }}
					</template>
					<template v-slot:[`item.paid`]="{ item }">
						<app-payment-status-button
							v-model="item.paid"
							block
						></app-payment-status-button>
					</template>
					<template v-slot:[`item.status`]="{ item }">
						<v-btn
							v-if="item.status == 'pending'"
							color="warning"
							class="white--text"
							small
							>{{ item.status }}</v-btn
						>
						<v-btn
							v-else-if="item.status == 'accepted'"
							color="success"
							class="white--text"
							small
							>{{ item.status }}</v-btn
						>
						<v-btn
							v-else-if="item.status == 'delivering'"
							color="primary"
							class="white--text"
							small
							>{{ item.status }}</v-btn
						>
						<v-btn
							v-else-if="item.status == 'delivered'"
							color="blue-grey"
							class="white--text"
							small
							>{{ item.status }}</v-btn
						>
						<v-btn
							v-else-if="item.status == 'completed'"
							color="indigo"
							class="white--text"
							small
							>{{ item.status }}</v-btn
						>

						<v-btn
							v-else-if="item.status == 'canceled'"
							color="red"
							class="white--text"
							small
							>{{ item.status }}</v-btn
						>
						<v-btn
							v-else
							color="success"
							class="white--text"
							small
							>{{ item.status }}</v-btn
						>
					</template>
					<template v-slot:[`item.view`]="{ item }">
						<v-btn
							color="success"
							small
							@click="
								$inertia.visit(
									$route('shop.order.view', {
										order: item.uuid,
									})
								)
							"
							>{{ $t("View") }}</v-btn
						>
					</template>
				</app-datatable>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
export default {
	props: ["orders"],
	data() {
		return {
			items: this.orders,
		};
	},
	computed: {
		endpoint() {
			return this.$route("shop.orders.index");
		},
		headers() {
			return [
				{
					text: this.$t("Code"),
					value: "code",
					sortable: false,
					searchable: false,
					width: 150,
				},
				{
					text: this.$t("Date"),
					value: "date",
					sortable: false,
					searchable: false,
					width: 250,
				},
				{
					text: this.$t("Time"),
					value: "time",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Outlet"),
					value: "outlet.name",
					sortable: false,
					searchable: false,
					width: 150,
				},
				{
					text: this.$t("Payment Method"),
					value: "payment_method_code",
					sortable: false,
					searchable: false,
					width: 180,
				},
				{
					text: this.$t("Subtotal"),
					value: "subtotal",
					sortable: false,
					searchable: false,
					width: 120,
				},
				{
					text: this.$t("Discount"),
					value: "discount",
					sortable: false,
					searchable: false,
					width: 120,
				},
				{
					text: this.$t("Total"),
					value: "total",
					sortable: false,
					width: 120,
					searchable: false,
				},
				{
					text: this.$t("Paid"),
					value: "paid",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Status"),
					value: "status",
					sortable: false,
					searchable: false,
					align: "right",
					width: 100,
				},
				{
					text: this.$t("View"),
					value: "view",
					sortable: false,
					searchable: false,
					width: 150,
				},
			];
		},
	},
};
</script>